import url from './url';

async function handleInstitucional() {

    let data = await fetch(`${url}/conteudo/list`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        method: 'get'
    }).then(res => res.json());

    return data;

}

export { handleInstitucional }